import React, { useState, useEffect } from 'react';
import ImageModal from './ImageModal';
import '../styles/Carousel.css';

const Carousel = ({ images, title, zoomable, className = '' }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [modalOpen, setModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState('');

  const nextSlide = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }
  };

  const prevSlide = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    }
  };

  const goToSlide = (index) => {
    if (!isTransitioning && index !== currentIndex) {
      setIsTransitioning(true);
      setCurrentIndex(index);
    }
  };

  const handleImageClick = (imageSrc) => {
    setModalImage(imageSrc);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalImage('');
  };

  const handleMouseMove = (e) => {
    if (!zoomable) return;
    
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    
    e.currentTarget.style.setProperty('--mouse-x', `${x}%`);
    e.currentTarget.style.setProperty('--mouse-y', `${y}%`);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsTransitioning(false);
    }, 500); // Match this with CSS transition duration

    return () => clearTimeout(timer);
  }, [currentIndex]);

  return (
    <>
      <div className={`carousel-wrapper ${className}`}>
        {title && <h3 className="carousel-title">{title}</h3>}
        <div className="carousel-container">
          <div className="carousel-track">
            {images.map((image, index) => (
              <div
                key={index}
                className={`carousel-slide ${index === currentIndex ? 'active' : ''} ${zoomable ? 'zoomable' : ''}`}
                style={{
                  transform: `translateX(${100 * (index - currentIndex)}%)`,
                }}
                onMouseMove={handleMouseMove}
              >
                <img 
                  src={image} 
                  alt={`Slide ${index + 1}`}
                  onClick={() => handleImageClick(image)}
                  style={{ cursor: 'pointer' }}
                />
              </div>
            ))}
          </div>
          
          <button className="carousel-button prev" onClick={prevSlide}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <button className="carousel-button next" onClick={nextSlide}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>

          <div className="carousel-dots">
            {images.map((_, index) => (
              <button
                key={index}
                className={`carousel-dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>
      </div>
      
      <ImageModal
        isOpen={modalOpen}
        imageSrc={modalImage}
        imageAlt={`Full size view of slide ${currentIndex + 1}`}
        onClose={closeModal}
      />
    </>
  );
};

export default Carousel; 